import { render, staticRenderFns } from "./LinhasDeProdutos.vue?vue&type=template&id=eb65d718"
import script from "./LinhasDeProdutos.vue?vue&type=script&lang=js"
export * from "./LinhasDeProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports